import { useNavigate } from 'react-router-dom';
import { Button } from '../ui/button';
import { MessageSquarePlus, MessageSquare } from 'lucide-react';
import { Separator } from '../ui/separator';
import ConversationList from './ConversationList';
import { UserProfile } from './UserProfile';
import { useUIStore } from '@/lib/store/uiStore';
import { env } from '@/config/env';

function Sidebar() {
  const navigate = useNavigate();
  const { isMobile, setSidebarOpen } = useUIStore();

  const handleNewChat = () => {
    // Navigate to home - conversation will be created on first message
    navigate('/');

    // Close sidebar on mobile after clicking new chat
    if (isMobile) {
      setSidebarOpen(false);
    }
  };

  return (
    <div className="h-full flex flex-col bg-card border-r border-gray-200">
      {/* Header */}
      <div className="p-2 space-y-4">
        {/* App Name & Logo */}
        <div className="flex items-center gap-2 px-2 py-1">
          {env.appLogoUrl ? (
            <img
              src={env.appLogoUrl}
              alt={env.appName}
              className="h-8 w-auto object-contain"
            />
          ) : (
            <div className="h-8 w-8 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
              <MessageSquare className="h-4 w-4 text-white" />
            </div>
          )}
          <h1 className="text-lg font-semibold text-foreground truncate">
            {env.appName}
          </h1>
        </div>

        <Button
          variant="primary"
          onClick={handleNewChat}
          className="w-full"
        >
          <MessageSquarePlus className="mr-2 h-4 w-4" />
          Nuova Chat
        </Button>
      </div>

      <Separator />

      {/* Conversations List */}
      <div className="flex-1 overflow-hidden p-2">
        <ConversationList />
      </div>

      {/* User Profile (Auth) */}
      <UserProfile />
    </div>
  );
}

export default Sidebar;
